import { render, staticRenderFns } from "./AccountShop.vue?vue&type=template&id=b96cb20c&scoped=true&"
import script from "./AccountShop.vue?vue&type=script&lang=js&"
export * from "./AccountShop.vue?vue&type=script&lang=js&"
import style0 from "./AccountShop.vue?vue&type=style&index=0&id=b96cb20c&lang=scss&scoped=true&"
import style1 from "./AccountShop.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96cb20c",
  null
  
)

export default component.exports